// The pictures of one organiser that still wait for a permission, as plain text for a DM:
// per picture the events it stands on, with their day, and the picture's address.

const day = (value) => {
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.valueOf())
    ? ''
    : date.toLocaleDateString('de-AT', { weekday: 'short', day: '2-digit', month: '2-digit' });
};

/** "Flucc Night – Fr., 17.10." or "Usus am Wasser – Club". */
const useLine = (use) => `${use.title}${use.eventDate ? ` – ${day(use.eventDate)}` : use.type === 'Club' ? ' – Club' : ''}`;

/** Whether a use still shows in the app: an event ahead, or a club. */
const current = (use) => use.type === 'Club' || !use.eventDate || use.upcoming;

/** The uses of a picture, its own first; older lists without uses count the picture itself. */
const usesOf = (picture) => (Array.isArray(picture.uses) && picture.uses.length
  ? picture.uses
  : [{ id: picture.id, title: picture.title, type: picture.type, eventDate: picture.eventDate, upcoming: picture.upcoming }]);

/** The pictures the list names: not cleared yet, and on at least one event ahead or a club. */
export const hiddenCurrentPictures = (pictures) => (pictures || [])
  .filter((picture) => !picture.cleared && usesOf(picture).some(current));

/** The list as text, or '' when nothing waits. */
export function hiddenPicturesText(pictures) {
  return hiddenCurrentPictures(pictures)
    .map((picture) => {
      const [first, ...more] = usesOf(picture).filter(current);
      const also = more.length ? ` (auch: ${more.map(useLine).join('; ')})` : '';
      return `${useLine(first)}${also}\n${picture.image}`;
    })
    .join('\n\n');
}
